import React from "react";

const HotelLoader = () => {
  return (
    <div className="space-y-6">
      <div className="grid grid-col-1 lg:grid-cols-3 gap-3 border p-3 rounded-lg">
        <div className="block lg:flex gap-3 col-span-2 ">
          <div className="flex-1">
            <div className="w-full bg-slate-200 animate-pulse h-[400px] overflow-hidden rounded-md border"></div>
          </div>
          <div className="py-3 lg:py-0 flex flex-row lg:flex-col gap-3">
            <div className="bg-slate-200 animate-pulse w-[50px] lg:w-[70px] h-[50px]  lg:h-[70px] overflow-hidden rounded-md"></div>
            <div className="bg-slate-200 animate-pulse w-[50px] lg:w-[70px] h-[50px]  lg:h-[70px] overflow-hidden rounded-md"></div>
            <div className="bg-slate-200 animate-pulse w-[50px] lg:w-[70px] h-[50px]  lg:h-[70px] overflow-hidden rounded-md"></div>
            <div className="bg-slate-200 animate-pulse w-[50px] lg:w-[70px] h-[50px]  lg:h-[70px] overflow-hidden rounded-md"></div>
            <div className="bg-slate-200 animate-pulse w-[50px] lg:w-[70px] h-[50px]  lg:h-[70px] overflow-hidden rounded-md relative"></div>
          </div>
        </div>
        <div className="space-y-8">
          <div>
            <div className="bg-slate-200 animate-pulse w-[200px] h-5 overflow-hidden rounded-md"></div>
            <div className="flex gap-2 pt-3">
              <div className="bg-slate-200 animate-pulse w-[30px] h-[30px] overflow-hidden rounded-md"></div>
              <div className="bg-slate-200 animate-pulse w-[130px] h-[30px] overflow-hidden rounded-md"></div>
            </div>
          </div>
          <div className="bg-slate-200 animate-pulse w-[80px] h-5 overflow-hidden rounded-md"></div>
          <div className="flex gap-2 pt-3">
            <div className="bg-slate-200 animate-pulse w-[30px] h-[30px] overflow-hidden rounded-md"></div>
            <div className="bg-slate-200 animate-pulse w-[130px] h-[30px] overflow-hidden rounded-md"></div>
          </div>
          <div className="bg-slate-200 animate-pulse w-[130px] h-[30px] overflow-hidden rounded-md"></div>
          <div className="bg-slate-200 animate-pulse w-[130px] h-[30px] overflow-hidden rounded-md"></div>
          <div className="bg-slate-200 animate-pulse w-full h-[50px] overflow-hidden rounded-md"></div>
        </div>
      </div>
      <div className="border p-3 rounded-lg">
        <div className="flex gap-2">
          <div className="bg-slate-200 animate-pulse w-[120px] h-[120px] overflow-hidden rounded-md"></div>
          <div className="flex flex-col gap-3 w-full">
            <div className="flex gap-2">
              <div className="bg-slate-200 animate-pulse w-[80px] h-[10px] overflow-hidden rounded-md"></div>
              <div className="bg-slate-200 animate-pulse w-[80px] h-[10px] overflow-hidden rounded-md"></div>
              <div className="bg-slate-200 animate-pulse w-[80px] h-[10px] overflow-hidden rounded-md"></div>
            </div>
            <div className="bg-slate-200 animate-pulse w-full h-5 overflow-hidden rounded-md"></div>
            <div className="bg-slate-200 animate-pulse w-full h-5 overflow-hidden rounded-md"></div>
            <div className="bg-slate-200 animate-pulse w-full h-5 overflow-hidden rounded-md"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HotelLoader;
